import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        const wpcf7Elm = this.el.querySelector('.wpcf7');
        const success = this.el.querySelector('.c-form_success');
 
        wpcf7Elm.addEventListener('wpcf7mailsent', (e) => {
            wpcf7Elm.classList.add('-sent');
            success.classList.add('-visible');
            this.call('scrollTop', 'Scroll');
            setTimeout(() => {
                this.call('setLight', 'Navbar');
            }, 300);
        });
    }
}
